<script setup lang="ts">
definePageMeta({
  layout: 'student'
})

// routing
const router = useRouter()
const route = useRoute()
const query = route.query

// admin
const { data: user, status } = useAuth()
const isAdmin = isClassAdmin(user.value)

// --------------------
// FORUM-BACKEND
// --------------------

const { listPostsReactive, getPost } = useForumPost()

const pageSize = 5

const listPostsReactiveQuery: Parameters<typeof listPostsReactive>[0] = reactive({
  page: 'page' in query ? parseInt(`${query.page}`) : 1,
  page_size: pageSize,
  order_by: '-created_date',
  search_query: '',
  select_activity_tags: null,
  is_resolved: null
})

const {
  data: listPosts,
  pending: listPostsLoading,
  refresh: refreshPosts
} = await listPostsReactive(listPostsReactiveQuery)

// Click pagination page
const clickPage = (index: number) => {
  // update reactive query, it will trigger the listPostsReactive to fetch new data
  listPostsReactiveQuery.page = index

  // update current URL
  router.replace(`/forum/feed?page=${index}`)

  // scroll to top of list
  const el = document.getElementById('feed-list') as HTMLElement
  scrollToSection(el)
}

const handlePostListRefresh = async (postId: string | null | undefined) => {
  if (!postId) {
    await refreshPosts()
    return
  }

  if (!listPosts.value?.data) return

  const updatedPost = await getPost(postId)
  const index = listPosts.value.data.findIndex((p) => p.id_slug === postId)

  if (index !== -1 && updatedPost) {
    // Type assertion since we know the shape matches
    type PostType = (typeof listPosts.value.data)[number]
    const typedUpdatedPost = updatedPost as PostType

    // Update the post with type safety
    Object.keys(typedUpdatedPost).forEach((key) => {
      if (key in listPosts.value!.data[index]) {
        ;(listPosts.value!.data[index] as any)[key] = typedUpdatedPost[key as keyof PostType]
      }
    })
  }
}
</script>

<template>
  <LayoutForumLayout>
    <div id="feed">
      <PageForumFeedHeader :active="0" :is-authenticated="status === 'authenticated'" />

      <div id="feed-list">
        <PageForumPostList
          :is-loading="listPostsLoading"
          :posts="listPosts?.data"
          :is-admin="isAdmin"
          :page-size="pageSize"
          @refresh="handlePostListRefresh"
        />
      </div>

      <PageJobsPagination
        v-if="listPosts && listPosts.num_pages > 1"
        :total="listPosts.num_pages"
        :current="listPostsReactiveQuery.page as number"
        @handle-click="clickPage"
      />
    </div>
  </LayoutForumLayout>
</template>

<style scoped lang="scss">
#feed {
  max-width: 800px;
  margin: 0 auto;
}

#feed-list {
  margin-top: 30px;
}
</style>
